// theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'black' : 'white', // Set default background colors for light and dark mode
        color: props.colorMode === 'dark' ? 'white' : 'black', // Set default text colors for light and dark mode
      },
    }),
  },
  colors: {
    rcBrand: {
      "forest": "#023F2E",       // Forest
      "evergreen": "#00853E",    // Evergreen
      "emerald": "#16A54A",      // Emerald
      "peridot": "#D5E14D",      // Peridot
      "wheat": "#F9F580",        // Wheat
      "lime": "#CCFF33",         // Lime
      "ocean": "#89DCC8",        // Ocean
      "parchment": "#EEF2E3",    // Parchment
      "sapphire": "#0A679B",     // Sapphire
      "sky": "#D5E7ED",          // Sky
      "rain": "#EEF0F7",         // Rain
      "cloud": "#FCFCFC",   // Cloud
      "teal":"#89DCC8", //Teal
      "olive": "#C5DC67"   // Olive
    },
    customGreen: {
      50: "#e0f6eb",
      100: "#b3e4cc",
      200: "#81d2ab",
      300: "#51c18b",
      400: "#25b370",
      500: "#00853E",
      600: "#006730",
      700: "#004923",
      800: "#002c16",
      900: "#001006",
    },
    customYellow: {
      50: "#f6f6d9",
      100: "#e9e9af",
      200: "#dbdb85",
      300: "#cccc5b",
      400: "#bdbd31",
      500: "#D5E14D",
      600: "#a6a63c",
      700: "#77772b",
      800: "#484819",
      900: "#1a1a08",
    },
    customGray: {
      50: "#f5f5f5",
      100: "#d4d4d4",
      200: "#b4b4b4",
      300: "#939393",
      400: "#737373",
      500: "#525252",
      600: "#414141",
      700: "#313131",
      800: "#212121",
      900: "#111111",
    },
  },
  components: {
    Select: {
      parts: ['field', 'menu'],
      baseStyle: (props) => ({
        field: {
          bg: props.colorMode === 'dark' ? 'black' : 'white', // Set dropdown trigger background
          color: props.colorMode === 'dark' ? 'white' : 'black', // Set dropdown trigger text color
          borderColor: props.colorMode === 'dark' ? 'white' : 'gray.400', // Set border color
        },
        menu: {
          bg: props.colorMode === 'dark' ? 'black' : 'white', // Set dropdown menu background
          color: props.colorMode === 'dark' ? 'black' : 'white', // Set dropdown menu text color
        },
        option: {
          bg: props.colorMode === 'dark' ? 'black' : 'white', // Set dropdown option background
          color: props.colorMode === 'dark' ? 'white' : 'black', // Set dropdown option text color
          _hover: {
            bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.200', // Hover state for options
          },
        },
      }),
    },
  },
});

export default theme;
